export default __webpack_public_path__ + "static/media/Heart.491d03b5.svg";